import { allFilms } from "./allFilms";

export const childrenAnniversaryFilms = allFilms.filter(function(obj) { return obj.type === 'Infantil'; });